module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-sun-9cb25ed3.svg";